import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Component, OnInit, Inject } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { LocaleService } from '@app/core/i18n';
import { environment } from '@env/environment';

@Component({
  selector: 'vc-add-pictures',
  templateUrl: './add-pictures.component.html',
  styleUrls: ['./add-pictures.component.scss']
})
export class AddPicturesComponent implements OnInit {
  public productId: number;
  public files: File[] = [];
  public acceptableExtensions = ['.jpeg', '.jpg'];
  public showError = false;
  public loading = false;
  public fileSent = false;
  public uploadError = '';
  public uploadTarget = environment.legacyLink + 'pict.php?idproduit=';

  constructor(
    @Inject(MAT_DIALOG_DATA) public datas: any,
    private httpClient: HttpClient,
    private localeService: LocaleService
  ) {}

  ngOnInit() {
    this.productId = this.datas.productId;
    const region = this.localeService.getLocale()['region'].toLowerCase();
    if (region !== 'gb') {
      this.uploadTarget = this.uploadTarget.replace(/www/, region);
    }
  }

  onFileSelected(selectedFiles: File[]) {
    this.files = [...selectedFiles];
    this.showError = false;
  }

  sendFiles() {
    this.loading = true;

    const processArray = (array, fn) => {
      return array.reduce(function(p, item) {
        return p.then(function() {
          return fn(item);
        });
      }, Promise.resolve());
    };

    const processItem = file => {
      const fileName =
        this.productId +
        '-' +
        this.files.indexOf(file) +
        '.' +
        file.name
          .split('.')
          .reverse()[0]
          .toLowerCase();
      return new Promise((resolve, reject) => {
        const formData: FormData = new FormData();
        formData.append('fileToUpload', file, fileName);
        const headers = new HttpHeaders();
        headers.set('Accept', 'application/json');
        this.httpClient.post(this.uploadTarget + this.productId, formData, { headers: headers }).subscribe(
          data => resolve(data),
          error => reject(error)
        );
      });
    };

    processArray(this.files, processItem).then(
      result => {
        const oResult = result;

        if (oResult && oResult.errorType) {
          this.uploadError = oResult.errorType;
          this.loading = false;
          this.showError = true;
        } else {
          this.loading = false;
          this.fileSent = true;
        }
      },
      error => {
        this.loading = false;
        this.showError = true;
      }
    );
  }
}
